// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.copyright[data-v-331254fc] {\n  text-align: center;\n  margin-top: 1rem;\n  margin-bottom: 0.5rem;\n}\n", ""]);
// Exports
module.exports = exports;
